import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const TabLabelNumberLabel = styled.div `
  ${({ disabled, mode }) => css `
    /* Color */
    color: ${disabled
    ? tokens.colors.midnight[200].value
    : tokens.colors.midnight[mode === 'light' ? 800 : 200].value};

    /* Text */
    font-family: ${tokens.font.family.sans.value};
    font-size: ${getFontSize('m')};
    font-weight: ${getFontWeight('medium')};
    line-height: ${getFontSize('l')};
    text-transform: uppercase;
  `}
`;
export const TabLabelNumberPosition = styled.div `
  ${({ disabled, mode, selected, selectedColor }) => css `
    /* Color */
    color: ${disabled
    ? tokens.colors.midnight[200].value
    : selected
        ? selectedColor
        : tokens.colors.midnight[mode === 'light' ? 300 : 800].value};

    /* Text */
    font-family: ${tokens.font.family.serif.value};
    font-size: ${getFontSize('2xl')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getFontSize('3xl')};
  `}
`;
export const TabLabelNumberRoot = styled.button `
  ${({ selected, selectedColor }) => css `
    /* Display & Box Model */
    align-items: center;
    border: none;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-radius: 0;
    display: flex;
    gap: ${getSpace('xs')};
    margin: 0;
    padding: ${getSpace('s')} ${getSpace('l')};

    /* Color */
    background-color: transparent;
    border-bottom-color: ${selected ? selectedColor : 'transparent'};

    /* Text */
    font: inherit;
    text-align: inherit;

    /* Miscellanea */
    cursor: pointer;

    :not([disabled]):hover {
      border-bottom-color: ${selected
    ? selectedColor
    : tokens.colors.midnight[400].value};
    }
  `}
`;
export const TabLabelNumberSeparator = styled.div `
  ${({ disabled, mode }) => css `
    /* Color */
    color: ${disabled
    ? tokens.colors.midnight[200].value
    : tokens.colors.midnight[mode === 'light' ? 300 : 800].value};

    /* Text */
    font-family: ${tokens.font.family.serif.value};
    font-size: ${getFontSize('2xl')};
    font-weight: ${getFontWeight('bold')};
    line-height: ${getFontSize('3xl')};
  `}
`;
//# sourceMappingURL=TabLabelNumber.styles.js.map